enum DeleteUserConstants {
  OPEN_DELETE_USER_MODAL = '@DeleteUserContainer/OPEN_DELETE_USER_MODAL',
  CLOSE_DELETE_USER_MODAL = '@DeleteUserContainer/CLOSE_DELETE_USER_MODAL',

  DELETE_USER = '@DeleteUserContainer/DELETE_USER',
  DELETE_USER_REQUEST = '@DeleteUserContainer/DELETE_USER_REQUEST',
  DELETE_USER_REQUEST_SUCCESS = '@DeleteUserContainer/DELETE_USER_REQUEST_SUCCESS',
  DELETE_USER_REQUEST_ERROR = '@DeleteUserContainer/DELETE_USER_REQUEST_ERROR',
  DELETE_USER_REQUEST_FORCE_PAGE_RELOAD = '@DeleteUserContainer/DELETE_USER_REQUEST_FORCE_PAGE_RELOAD',
}

export default DeleteUserConstants;
